module.exports = __webpack_public_path__ + "img/di_16_Rec.be2fab37.png";